import { render } from "./ThreeDCharacter.vue?vue&type=template&id=7644cf28&scoped=true"
import script from "./ThreeDCharacter.vue?vue&type=script&lang=js"
export * from "./ThreeDCharacter.vue?vue&type=script&lang=js"

import "./ThreeDCharacter.vue?vue&type=style&index=0&id=7644cf28&scoped=true&lang=css"

import exportComponent from "/Users/macpc-2/Downloads/Sitepal-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7644cf28"]])

export default __exports__